// extracted by mini-css-extract-plugin
export default {"remember_me":"RememberMe_remember_me__4XV8F"};